export default {"src":"/_next/static/media/shoppingBag.24f651aa.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};